const TitleYellow = ({ title = '', titleYellow = '', fontSize = '36px', className = '' }) => {
  return (
    <h2 className={className} style={{ fontSize: fontSize }}>
      {title} <span style={{ color: 'var(--corporative-yellow)' }}>{titleYellow}</span>
    </h2>
  );
};

export default TitleYellow;
